import { render } from "./SponsoredSalesCard.vue?vue&type=template&id=5dec5846"
import script from "./SponsoredSalesCard.vue?vue&type=script&lang=js"
export * from "./SponsoredSalesCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__